/**
 * @fileoverview AR-924 — Single switch point for the teacher-upload port: HTTP adapter at runtime,
 * in-memory mock (Jest / review without a backend) behind a localStorage flag.
 */

import type { TaskTrackMatrix } from '../types'
import type { TeacherDeliverablePort } from './ports'
import { httpTeacherDeliverableAdapter } from './adapters/httpAdapter'
import { mockTeacherDeliverableAdapter } from './adapters/mockAdapter'
import { decorateMatrixWithMockUploads } from './mockMatrix'

/** Dev-only override: `localStorage.setItem('task-tracker-teacher-upload-mock', '1')`. */
export const TEACHER_UPLOAD_MOCK_KEY = 'task-tracker-teacher-upload-mock'

export function teacherUploadUsesMock(): boolean {
  try {
    return window.localStorage.getItem(TEACHER_UPLOAD_MOCK_KEY) === '1'
  } catch {
    return false
  }
}

export function getTeacherDeliverablePort(): TeacherDeliverablePort {
  return teacherUploadUsesMock() ? mockTeacherDeliverableAdapter : httpTeacherDeliverableAdapter
}

/** Called by the matrix loaders after the fetch — never during render (it writes to the mock store). */
export function decorateMatrixForReview(matrix: TaskTrackMatrix): TaskTrackMatrix {
  return teacherUploadUsesMock() ? decorateMatrixWithMockUploads(matrix) : matrix
}
